module.exports = __webpack_public_path__ + "img/MAC1120_1-1.0a633429.jpg";